import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/Login";
import AppShell from "@/components/AppShell";
import AdminOverview from "@/pages/AdminOverview";
import LeadsPage from "@/pages/Leads";
import PositionsPage from "@/pages/Positions";
import CandidatesPage from "@/pages/Candidates";
import UsersPage from "@/pages/Users";
import ProfilePage from "@/pages/Profile";
import MySubmissionsPage from "@/pages/MySubmissions";
import RecruiterHome from "@/pages/RecruiterHome";

function ProtectedRoute({ children, allowed }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function HomeRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <AdminOverview />;
  if (user.role === "recruiter") return <RecruiterHome />;
  if (user.role === "research_analyst") return <LeadsPage />;
  return <div>Unknown role</div>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/leads" element={
          <ProtectedRoute allowed={["admin", "research_analyst"]}><LeadsPage /></ProtectedRoute>
        } />
        <Route path="/positions" element={
          <ProtectedRoute allowed={["admin", "recruiter", "research_analyst"]}><PositionsPage /></ProtectedRoute>
        } />
        <Route path="/candidates" element={
          <ProtectedRoute allowed={["admin"]}><CandidatesPage /></ProtectedRoute>
        } />
        <Route path="/my-submissions" element={
          <ProtectedRoute allowed={["recruiter"]}><MySubmissionsPage /></ProtectedRoute>
        } />
        <Route path="/users" element={
          <ProtectedRoute allowed={["admin"]}><UsersPage /></ProtectedRoute>
        } />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
